<template>
  <router-link :to="{name: 'qvct-survey-view', params: {id: survey.id}}" class="card border card-container">
    <div class="card-header bg-gray image-container" >
      <img src="/assets/media/qvct/survey-form-image.png" alt="Survey form image">
    </div>

    <div class="card-body px-4 py-5">
      <div class="fs-5 fw-bold ellipsis" title="Bien-être au travail">{{ survey.name }}</div>
      <div class="pt-2 d-flex align-items-center justify-content-between flex-nowrap">
        <div class="d-flex align-items-center">
          <span class="badge me-3" :class="[statusBadge]">{{ survey.status[locale] }}</span>
<!--          <span class="text-base"> Dernière ouverture 10:13</span>-->
        </div>
        <i class="fas fa-ellipsis-v fs-4"></i>
      </div>
    </div>
  </router-link>
</template>
<script setup>
import {computed, defineProps} from "vue";
import {useLocales} from "@/composables/locales";


const { locale } = useLocales()
  const props = defineProps({
    survey: Object,
  })

const statusBadge = computed(() => {
  return `badge-${props.survey?.status?.color || 'secondary'}`
})

</script>

<style scoped>
  .image-container {
    width: 100%;
    overflow: hidden;
    background-color: #F3F3F3;
    padding: 10px 8px;
  }

  .image-container img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  .card-container {
    transform: translateY(-5px);
    transition: transform 0.3s ease;
    outline: 1px solid #e8e8e8;
    border: 1px solid rgba(0, 0, 0, 0.02);
  }

  .ellipsis {
    white-space: nowrap;        /* empêche le retour à la ligne */
    overflow: hidden;           /* cache le débordement */
    text-overflow: ellipsis;    /* ajoute "..." à la fin */
  }
</style>